<template>
    <div >
      <!-- <input type="button" value="Add new row" @click="() => spreadsheet.insertRow()" />
      <input type="button" value="Add new Column" @click="() => spreadsheet.insertColumn()" /> -->

        <!-- <b-container> -->
          <b-row>
            <b-form @submit="onSubmit" v-if="show">

      <b-form-group id="input-group-2" label="Value" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.name"
          required
          placeholder="Enter Value"
        ></b-form-input>
      </b-form-group>
      <div ref="spreadsheet"></div>
      <br>
      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
    </b-row>
    <!-- </b-container> -->
  </div>
</template>
<script>
import jexcelStyle from "jexcel/dist/jexcel.css";
import jexcel from "jexcel";
import {postService} from '@/services/post.service'
export default {
  data() {
    return {
      dataList: [],
      spreadsheet: '',
options: {
  data: [['']],
  // allowToolbar:true,
  columns: []
  },
  form: {
          name: '',
        },
        show: true
}
  },
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    option: {
      type: Object,
      default: () =>  ({
        year: '',
        month: '',
        label_id: '',
        branch_id: '',
        amount: 0
      })
    }
  },
  created () {
    this.dataList = this.listData
    this.form.name = this.option.amount
  },
  watch: {
    listData () {
      this.dataList = this.listData
      this.form.name = this.option.amount
    },
  },
    mounted () {
        this.options.data = this.dataList
        const spred = this.$refs.spreadsheet
        this.spreadsheet = jexcel(spred, this.options)
        let spreadsheet = this.spreadsheet
        Object.assign(this, {spreadsheet})
    },
    methods: {
        onSubmit(evt) {
        evt.preventDefault()
        const data = this.spreadsheet.getData()
        const body = {
            year: this.option.year,
            month: this.option.month,
            label_id: this.option.label_id,
            branch_id: this.option.branch_id,
            amount: this.form.name,
            amount_detail: JSON.stringify(data)
        }
        const id = 'metric-' + this.option.label_id + 'month-' + this.option.month
        document.getElementById(id).innerHTML = this.form.name
        // postService.postMetricExcel(body)
        //   .then(data => {
        //     // console.log(data)
        //   })
      },
    }
}
</script>